import React, { Component } from 'react';
import {Jumbotron, Form, Button } from 'react-bootstrap';

 export class TodoApp extends  Component {
  constructor(props) {
    super(props);
    this.state = { items: [], text: '' };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    return (
      <Jumbotron fluid>
        <h1>TODO</h1>
        <TodoList items={this.state.items} />
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Label htmlFor="new-todo">
            What needs to be done?
          </Form.Label>
            <Form.Control type="text" 
            id="new-todo"
            onChange={this.handleChange}
            value={this.state.text}
          />
            </Form.Group>
          <Button variant="danger" type="submit">
            Add #{this.state.items.length + 1}
          </Button>
        </Form>
      </Jumbotron>
    );
  }

  handleChange(e) {
    this.setState({ text: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.state.text.length) {
      return;
    }
    const newItem = {
      text: this.state.text,
      id: Date.now()
    };
    this.setState(state => ({
      items: state.items.concat(newItem),
      text: ''
    }));
  }
}


class TodoList extends Component {
  render() {
    return (
      <ol>
        {this.props.items.map(item => (
          <li key={item.id}>{item.text}</li>
        ))}
      </ol>
    );
  }
}

